import styled from "styled-components";

import { theme } from "../../../styles/theme";

interface IProps {
  canceled: boolean;
}

export const Container = styled.div`
  padding: 15px;
  width: 100%;
  margin-bottom: 15px;
  gap: 15px;
  background-color: ${theme.colors.darkBlue};
  border-radius: ${theme.border.normal};
  display: flex;
  flex-direction: column;

  font-family: ${theme.font.poppins};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 10px;
`;

export const HeadingInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div<IProps>`
  font-size: 14px;
  margin-bottom: 5px;
  color: ${({ canceled }) =>
    canceled ? theme.colors.red : theme.colors.blue100};
`;

export const Subtitle = styled.div<IProps>`
  font-size: 12px;
  color: ${({ canceled }) =>
    canceled ? theme.colors.red : theme.colors.white};
  font-weight: ${theme.font.xbold};
`;

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 5px;
`;

export const Value = styled.div<IProps>`
  font-size: 12px;
  color: ${(props) =>
    props.canceled ? theme.colors.red : theme.colors.gray400};
  font-weight: ${theme.font.normal};
`;
